// src/pages/home/Index.jsx
import React from "react";
// NEW: import Element to create scroll anchors
import { Element } from "react-scroll";

import HeroBanner from "./HeroBanner";
import ServicesSection from "./ServicesSection";
import GrowthSection from "./GrowthSection";
import WhyBizverto from "./WhyBizverto";
import IndustriesSection from "./IndustriesSection";
import CTASection from "./CTASection";

export default function Home() {
  return (
    <div>
      {/* NEW: each Element 'name' is the target for smooth scrolling */}
      <Element name="hero"><HeroBanner /></Element>
      <Element name="services"><ServicesSection /></Element>
      <Element name="growth"><GrowthSection /></Element>
      <Element name="why"><WhyBizverto /></Element>
      <Element name="industries"><IndustriesSection /></Element>
      <Element name="cta"><CTASection /></Element>
    </div>
  );
}
